/**
 * 📜 SMART LEGAL PAGE
 * Affiche les pages légales selon le domaine (LPE ou Heartbeats)
 */

import React from 'react';
import CGUPage from '../pages/CGUPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import HeartbeatsMentionsLegales from '../pages/HeartbeatsMentionsLegales';
import HeartbeatsCGU from '../pages/HeartbeatsCGU';
import HeartbeatsConfidentialite from '../pages/HeartbeatsConfidentialite';

const SmartLegalPage = ({ type }) => {
  // Détecter le domaine
  const hostname = window.location.hostname;
  const referrer = document.referrer || '';
  const urlParams = new URLSearchParams(window.location.search);
  
  // Détecter si on vient de Heartbeats (domaine, referrer, ou paramètre URL)
  const isHeartbeatsDomain = 
    hostname === 'heartbeats.fr' || 
    hostname === 'www.heartbeats.fr' ||
    hostname.includes('heartbeats') ||
    referrer.includes('heartbeats-preview') ||
    referrer.includes('rencontre-') ||
    urlParams.get('from') === 'heartbeats';
  
  const goBack = () => window.history.back();
  
  // Afficher les pages Heartbeats
  if (isHeartbeatsDomain) {
    switch (type) {
      case 'cgu':
        return <HeartbeatsCGU onBack={goBack} />;
      case 'privacy':
        return <HeartbeatsConfidentialite onBack={goBack} />;
      case 'mentions':
        return <HeartbeatsMentionsLegales onBack={goBack} />;
      default:
        return <HeartbeatsCGU onBack={goBack} />;
    }
  }
  
  // Afficher les pages LPE (par défaut)
  switch (type) {
    case 'cgu':
      return <CGUPage onBack={goBack} />;
    case 'privacy':
      return <PrivacyPolicyPage onBack={goBack} />;
    case 'mentions':
      return <CGUPage onBack={goBack} />;
    default:
      return <CGUPage onBack={goBack} />;
  }
};

export default SmartLegalPage;
